<script setup lang="ts">
import { onBeforeUnmount, onMounted } from 'vue'
import { useHead } from '@unhead/vue'
import VideoSubtitleRemovalPage from './VideoSubtitleRemovalPage.vue'

let ro: ResizeObserver | null = null
let raf = 0
let lastH = 0

useHead(() => ({
  htmlAttrs: { 'data-embed': 'video-subtitle-removal' },
  meta: [{ name: 'robots', content: 'noindex, nofollow' }],
}))

function postHeight() {
  if (typeof window === 'undefined') return
  if (raf) cancelAnimationFrame(raf)
  raf = requestAnimationFrame(() => {
    const root = document.querySelector('[data-embed-root]') as HTMLElement | null
    const rootBottom = root ? Math.ceil(root.getBoundingClientRect().bottom + window.scrollY) : 0
    const minH = window.innerWidth < 640 ? 620 : 580
    const next = Math.max(minH, rootBottom || 0)
    if (!next || Math.abs(next - lastH) < 2) return
    lastH = next
    try {
      window.parent?.postMessage({ type: 'embed-height', id: 'video-subtitle-removal', height: next }, '*')
    } catch {}
  })
}

onMounted(() => {
  if (typeof window === 'undefined') return
  try {
    ro = new ResizeObserver(() => postHeight())
    ro.observe(document.documentElement)
  } catch {}
  postHeight()
  window.addEventListener('load', postHeight, { once: true })
})

onBeforeUnmount(() => {
  if (raf) cancelAnimationFrame(raf)
  try {
    ro?.disconnect()
  } catch {}
  ro = null
})
</script>

<template>
  <VideoSubtitleRemovalPage :embed="true" canonical-path="/embed/video-subtitle-removal/" />
</template>

<style>
html[data-embed='video-subtitle-removal'],
html[data-embed='video-subtitle-removal'] body,
html[data-embed='video-subtitle-removal'] #app {
  background: transparent !important;
}

html[data-embed='video-subtitle-removal'],
html[data-embed='video-subtitle-removal'] body {
  overflow: hidden !important;
}

html[data-embed='video-subtitle-removal']::-webkit-scrollbar,
html[data-embed='video-subtitle-removal'] body::-webkit-scrollbar {
  width: 0;
  height: 0;
}
</style>
